import { useState, type FormEvent } from "react";

import { api, ErrorApi } from "../api";
import { Alert, Button, Card, Heading, Input, Text, Wordmark } from "../ds";
import s from "./Entrar.module.css";

/* Inicio de sesión. Es la única pantalla pública del panel: el servidor deja una cookie y
 * después `onEntro` vuelve a pedir la sesión. */
export function Entrar({ onEntro }: { onEntro: () => void }) {
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function entrar(e: FormEvent) {
    e.preventDefault();
    if (enviando) return;
    setEnviando(true);
    setError(null);
    try {
      await api("/api/sesion/entrar", { metodo: "POST", cuerpo: { usuario: usuario.trim(), clave } });
      onEntro();
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : "No se pudo iniciar sesión. Probá de nuevo.");
      setEnviando(false);
    }
  }

  return (
    <main className={s.fondo}>
      <Card tone="elevated" radius="xl" padding="lg" className={s.tarjeta}>
        <div className={s.marca}>
          <Wordmark size="lg" elevated as="div" />
          <div>
            <Heading level={1} size="lg">
              Entrá al panel
            </Heading>
            <Text size="sm" tone="muted">
              Prospección de inmobiliarias. Usá tu email y la clave del equipo.
            </Text>
          </div>
        </div>
        <form className={s.formulario} onSubmit={entrar} noValidate>
          <Input
            id="usuario"
            label="Email"
            type="email"
            size="lg"
            autoComplete="username"
            autoFocus
            required
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
          />
          <Input
            id="clave"
            label="Clave"
            type="password"
            size="lg"
            autoComplete="current-password"
            required
            value={clave}
            onChange={(e) => setClave(e.target.value)}
          />
          {error ? (
            <Alert tone="danger" compact>
              {error}
            </Alert>
          ) : null}
          <Button type="submit" size="lg" fullWidth pending={enviando} disabled={!usuario.trim() || !clave}>
            Entrar
          </Button>
        </form>
      </Card>
    </main>
  );
}
